module.exports = __webpack_public_path__ + "img/bim6.3967b45a.png";